import { combineReducers } from "redux";

import LoginResponse from "./loggedInUser";

import OwnerList from "./manage-property/property-owner/owner/owner-list";
import Locations from "./Locations/locations";
import BusinessUnit from "./BusinessUnit/businessUnit";
import LoiList from "./manage-property/property-loi/LOIDetails/loi-details";
import MainAgreement from "./manage-property/property-agreement/mainAgreement-details";
import SubAgreement from "./manage-property/property-agreement/subAgreement-details";
import PropertyOwner from "./property-owner";
import PropertyOwnerList from "./property-owner/propertyOwner-details";
import ManageRole from "./manageRoles";
import FeatureSlice from "./feature";
import RegionSlice from "./region";
import SalutationSlice from "./salutation";
import Auth from "./Auth";
import BrokerFirm from "./broker/brokerFirm";
import BrokerOwner from "./broker/brokerOwner";
import BrokerUser from "./broker/brokerUser";
import CityReducer from "./city";
import ClientReducer from "./client";
import ClientSpocReducer from "./client-spoc";

import CountryReducer from "./country";
import FloorReducer from "./floor";
import IndustryReducer from "./industry";
import newLeadReducer from "./lead";
import Leads from "./Leads";
import LocationReducer from "./location";
import SuiteReducer from "./suite";
import SmartProposal from "./smart-proposal";
import StateReducer from "./state";
import Theme from "./Theme";
import BusinessCenter from "./businessCenter";
import manageUser from "./manageUsers";
import publicProposal from "./public-proposal";
import AgreementSlice from "./smartSuiteAgreement";
import SideMenuSlice from "./getSideMenu";
import AccountReducer from "./account";
import KPISSlice from "./kpis";
import Workstation from "./workstation";
import ClientExitChecklistReducer from "./clientExitChecklist";
import OccupancyTrackerSlice from "./occupancyTracker";
import Dashboard from "./dashboard";
import Permissions from "./permissions";
import reducersacclgl from "./acclgl";
import MomSlice  from "./mom";
import marketingLeadReducer from "./marketingLead";
const reducers = combineReducers({
  theme: Theme,
  // auth: Auth,
  brokerFirm: BrokerFirm,
  brokerOwner: BrokerOwner,
  brokerUser: BrokerUser,
  ownerList: OwnerList,
  locations: Locations,
  loiList: LoiList,
  mainAgreement: MainAgreement,
  subAgreement: SubAgreement,
  propertyOwner: PropertyOwner,
  propertyOwnerList: PropertyOwnerList,
  leads: Leads,
  smartProposal: SmartProposal,
  newLead: newLeadReducer,
  location: LocationReducer,
  suite: SuiteReducer,
  floor: FloorReducer,
  state: StateReducer,
  city: CityReducer,
  country: CountryReducer,
  industry: IndustryReducer,
  client: ClientReducer,
  
  clientSpoc: ClientSpocReducer,
  businessCenter: BusinessCenter,
  manageRole: ManageRole,
  manageUser: manageUser,
  featureSlice: FeatureSlice,
  region: RegionSlice,
  salutation: SalutationSlice,
  publicProposal: publicProposal,
  auth: LoginResponse,
  smartSuiteAgreements: AgreementSlice,
  sidemenu: SideMenuSlice,
  businessUnit: BusinessUnit,
  Account: AccountReducer,
  kpis: KPISSlice,
  workstation: Workstation,
  clientexitchecklist: ClientExitChecklistReducer,
  occupancy: OccupancyTrackerSlice,
  mom : MomSlice,
  dashboard: Dashboard,
  permissions: Permissions,
  marketingLead: marketingLeadReducer,
  ...reducersacclgl,
});

export default reducers;
